import { typographyScale } from "@maeiz/tokens";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function TypographyPage() {
    const entries = Object.entries(typographyScale);
    return (
        <DocPage
            title="Typography"
            description="Unified Workspace type system: Montserrat (display), Roboto (body), JetBrains Mono (KPI / code)."
        >
            <Section title="Families">
                <SpecTable
                    rows={[
                        ["font-display", "Montserrat — titles, section heads, KPIs labels"],
                        ["font-sans", "Roboto — body, labels, forms, tables"],
                        ["font-mono", "JetBrains Mono — amounts, IDs, code"],
                    ]}
                />
            </Section>
            <Section title="Scale">
                <Demo>
                    <div className="space-y-4">
                        <p className="font-display text-4xl font-extrabold tracking-tight text-neutral-ink dark:text-white">
                            Display
                        </p>
                        <p className="font-display text-3xl font-extrabold text-neutral-ink dark:text-white">
                            Page title
                        </p>
                        <p className="font-display text-xl font-semibold">Section heading</p>
                        <p className="font-display text-lg font-semibold">Subsection</p>
                        <p className="text-base">Body — operational copy and descriptions.</p>
                        <p className="text-sm text-neutral-secondary">Body small / helper</p>
                        <p className="text-sm font-medium">Label</p>
                        <p className="text-xs uppercase tracking-[0.08em] text-neutral-secondary">
                            Overline
                        </p>
                        <p className="font-mono text-3xl font-bold tabular-nums text-primary">
                            12,450.00
                        </p>
                        <p className="font-mono text-sm">txn_01HXYZ</p>
                    </div>
                </Demo>
            </Section>
            <Section title="Token table">
                <SpecTable
                    rows={entries.map(([k, v]) => [
                        k,
                        `${v.size} / ${v.lineHeight} / w${v.weight} / ${v.family}`,
                    ])}
                />
            </Section>
            <Section title="Rules">
                <ul className="list-disc space-y-1 ps-5">
                    <li>Use `tabular-nums` for money and bottle counts.</li>
                    <li>
                        Truncate long names with ellipsis; never wrap table primary columns
                        awkwardly.
                    </li>
                    <li>Max readable line length ~70ch for prose blocks.</li>
                    <li>Do not load Sora/Outfit in Workspace apps — display/sans/mono only.</li>
                </ul>
            </Section>
        </DocPage>
    );
}
